// import CircularProgress from '@mui/material/CircularProgress';
import logo from "./LC-Logo_optimiert.svg"



export default function  Loading( props) {
   const {text} = props;
   return( <><div style={{position: 'absolute', top: '50%', left:'50%', transform: 'translateX(-50%) translateY(-50%)'}} > <img className="App-logo" src={logo} width='300' alt='Linux-Cafe Stuttgart lädt...' 
 />
   <p>{text ? text: 'wird geladen ...' }</p></div> 
</>);

}